/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleNumber7 = createReactComponent("circle-number-7", "IconCircleNumber7", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 8h4l-2 8", key: "svg-1" }]
]);

export { IconCircleNumber7 as default };
//# sourceMappingURL=IconCircleNumber7.js.map
